import { Component, OnInit } from '@angular/core';
import { NotificationService, ToastType } from 'src/app/services/notification.service';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
isShowSuccessNotification: boolean = false;
isShowWarningNotification: boolean = false;
isShowErrorNotification: boolean = false;
isShowHighlightNotification: boolean = false;
translationData: any;
notificationMessage: string = '';
notificationType: any = '';

constructor(private readonly notificationService: NotificationService, 
  private readonly translationService: TranslationService){

}

ngOnInit(){
  
   this.notificationService.notificationState$.subscribe(state => {
        this.notificationMessage = state.notificationMessage;
        this.notificationType = state.notificationType;
        this.showNotification(this.notificationType)
      });
}

showNotification(notificationType: any) {
    switch (notificationType) {
      case ToastType.Success:
        this.isShowSuccessNotification = true;
        break;
      case ToastType.Error:
        this.isShowErrorNotification = true;
        break;
      case ToastType.Warning:
        this.isShowWarningNotification = true;
        break;
      case ToastType.Highlight:
        this.isShowHighlightNotification = true;
        break;
    }
  }

  getNotificationVariant(): string {
    if (this.isShowSuccessNotification) return 'success';
    if (this.isShowWarningNotification) return 'warning';
    if (this.isShowErrorNotification) return 'error';
    if (this.isShowHighlightNotification) return 'highlight';
    return '';
  }

  getNotificationBorder(): string {
    if (this.isShowSuccessNotification) return '2px solid #198025';
    if (this.isShowWarningNotification) return '2px solid #efc406';
    if (this.isShowErrorNotification) return '2px solid #d92121';
    if (this.isShowHighlightNotification) return '2px solid #008dfc';
    return '';
  }

  getNotificationIcon(): string {
    if (this.isShowHighlightNotification && this.notificationMessage==='CP_LM_TOAST_MSG_COPIEDTOCLIPBOARD') return 'bds/link/24';
    if (this.isShowHighlightNotification && this.notificationMessage==='CP_SM_ASSET_GENERAYION_INPROGRESS') return 'bds/exclamation-mark-circle/24';
    return ''; // Return an empty string or a default icon if needed
  }

 handleDismiss(_event: CustomEvent): void {
    this.notificationService.closeNotification();
    this.isShowSuccessNotification = false;
    this.isShowWarningNotification = false;
    this.isShowErrorNotification = false;
    this.isShowHighlightNotification = false;
  }


}
